// extracted by mini-css-extract-plugin
module.exports = {"bestFromMNE":"BestFromMNE_bestFromMNE__69l5M","title":"BestFromMNE_title__2V3q7"};